import { useReactFlow } from '@xyflow/react';
import { memo, useCallback, useState } from 'react';
import { DialogTrigger } from 'react-aria-components';

import { Button, Heading } from '@/components/core';
import { ExportOption, NewExportModal } from '@/components/flow';
import { AddIcon } from '@/components/icons';
import { useAddExport } from '@/hooks';

export type EmptyExportNodeContentProps = {
  agentId: string;
};

const IEmptyExportNodeContent = ({ agentId }: EmptyExportNodeContentProps) => {
  const [newExportModelOpened, setNewExportModalOpened] = useState(false);
  const builder = useReactFlow();
  const onSuccess = useCallback(() => {
    builder.setNodes((nodes) => nodes);
    setNewExportModalOpened(false);
  }, [builder]);
  const { addExport, isPending: isAddingExport, errors: addExportErrors } = useAddExport({ onSuccess });

  const onExportOptionSelected = useCallback(
    (exportOption: ExportOption) => {
      addExport({ agentId, exportOption }).catch(console.error);
    },
    [addExport, agentId]
  );

  return (
    <DialogTrigger>
      <Button
        variant="plain"
        className="flex h-[4rem] w-full items-center justify-center gap-2"
        onPress={() => setNewExportModalOpened(true)}
      >
        <AddIcon variant="trigger" />
        <Heading>Add export</Heading>
      </Button>
      <NewExportModal
        isAddingExport={isAddingExport}
        isOpen={newExportModelOpened}
        onExportOptionSelected={onExportOptionSelected}
        onOpenChange={() => setNewExportModalOpened(false)}
        errors={addExportErrors}
      />
    </DialogTrigger>
  );
};

export const EmptyExportNodeContent = memo(IEmptyExportNodeContent) as typeof IEmptyExportNodeContent;
